import { onMounted, onBeforeUnmount } from 'vue'

/**
 * Pegar imagen desde el portapapeles (Ctrl/Cmd+V) en cualquier punto de la
 * página. El listener vive en `window` y se limpia al desmontar el componente
 * que lo monta (cada dropzone), por eso el paste solo está activo donde hay
 * una zona de drop visible.
 *
 * Solo actúa si el portapapeles contiene un File de imagen; si es texto (p. ej.
 * pegar una URL en un input) no hace nada y deja el paste nativo seguir.
 */
function imageFileFromClipboard(e) {
  const items = e.clipboardData?.items
  if (!items) return null
  for (const item of items) {
    if (item.kind === 'file' && item.type.startsWith('image/')) {
      const file = item.getAsFile()
      if (file) return file
    }
  }
  return null
}

export const useImagePaste = (onImageFile) => {
  const handler = (e) => {
    const file = imageFileFromClipboard(e)
    if (!file) return
    e.preventDefault()
    onImageFile(file)
  }
  onMounted(() => window.addEventListener('paste', handler))
  onBeforeUnmount(() => window.removeEventListener('paste', handler))
}
